import { Component, Directive, ContentChildren, TemplateRef, QueryList, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { WindowResizeService } from '../../global/window-resize.service';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

export enum FILTER_TYPES {
  DATEPICKER = 'datepicker'
}

@Directive({
  standalone: false,
  selector: '[dsp-content-filter]'
})
export class ContentFilterDirective {
}

@Component({
  standalone: false,
  selector: 'dsp-content-card',
  templateUrl: './content-card.component.html',
  styleUrls: ['./content-card.component.scss'],
})
export class ContentCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  public loading: boolean;

  @Input()
  public types: string[] = [];

  @Input()
  public header = true;

  @Input()
  public customMargin: number;

  @ContentChildren(ContentFilterDirective, { read: TemplateRef })
  public filters: QueryList<TemplateRef<ContentFilterDirective>>;

  public isMobile$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public margin$: BehaviorSubject<number> = new BehaviorSubject(-75);

  private readonly subscription = new Subscription();

  public constructor(
    private readonly resize: WindowResizeService
  ) {
  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeIsMobile());
    this.subscription.add(this.subscribeMargin());
  }

  public ngOnChanges(): void {
    this.resize.filters$.next(this.types.length);
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public isDatepicker(index: number): boolean {
    return this.types[index] === FILTER_TYPES.DATEPICKER;
  }

  private subscribeIsMobile(): Subscription {
    return this.resize.mobile$.subscribe(this.isMobile$);
  }

  /**
   * Sets negative margin to overlap content over hero in main.component
   * Each mobile filter is 71px height (including margins) + 3px for upper border
   * Multiply by -1 to turn resulting value negative
   * If not on mobile, default of -75 is used (or customMargin if provided)
   */
  private subscribeMargin(): Subscription {
    const defaultMargin = this.customMargin !== undefined ? this.customMargin : -75;
    return this.resize.mobile$.pipe(
      map(isMobile => this.types.length ? (isMobile ? ((this.types.length * 71) + 3) * -1 : defaultMargin) : defaultMargin)
    ).subscribe(this.margin$);
  }
}
